import React from 'react'
import { useSearchParams, Navigate } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'

import { useCurrentUser } from '~/client/hooks/auth'
import QuickSignupForm from '~/client/components/QuickSignupForm'
import DataPalLogo from '~/client/components/DataPalLogo'

export default function LoginPage() {
  const { currentUser } = useCurrentUser()
  const [ searchParams ] = useSearchParams()
  const returnTo = searchParams.get('returnTo') || '/'
  if (currentUser) return <Navigate to={returnTo}/>
  return <Paper sx={{
    m: 2,
    p: 2,
    mx: 'auto',
    width: '400px',
  }}>
    <Stack alignItems="center" sx={{textAlign: 'center'}}>
      <DataPalLogo variant="white" size="lg" sx={{mb:2}}/>
      <Typography variant="h6" sx={{fontWeight: 100}}>
        {`Sign up to DataPal`}
      </Typography>
    </Stack>
    <QuickSignupForm returnTo={returnTo}/>
  </Paper>
}
